import type { HTMLAttributes } from 'react'
import { cn } from '../cn.ts'

export type ChipTone = 'neutral' | 'pop' | 'apricot' | 'green' | 'sky'

const tones: Record<ChipTone, string> = {
  neutral: 'bg-grey-2 text-text-2',
  pop: 'bg-pop-tint text-pop-fg',
  apricot: 'bg-apricot-bg text-apricot-fg',
  green: 'bg-green-bg text-green-fg',
  sky: 'bg-sky-bg text-sky-fg',
}

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone
}

export function Chip({ tone = 'neutral', className, ...rest }: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-1 rounded-pill px-2.5 font-medium text-xs',
        tones[tone],
        className,
      )}
      {...rest}
    />
  )
}
